import {
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { tap } from 'rxjs/operators';
import { HttpErrorHandler } from './http-error-handler';

@Injectable()
export class UnauthorizedInterceptor implements HttpInterceptor {
  private httpErrorHandler = inject(HttpErrorHandler);

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    return next.handle(req).pipe(
      tap({
        error: (response: unknown) =>
          this.httpErrorHandler.handleUnauthorized(response),
      }),
    );
  }
}
